(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page"]) return;
  try {
    
  (() => {
    const initClientifyForm = (container) => {
      if (!container || container.dataset.clientifyState) return;

      const formId = container.dataset.clientifyFormId;
      if (!/^\d+$/.test(formId || '')) return;

      const formUrl = `https://api.clientify.net/web-marketing/webforms/script/${formId}.js`;
      const expectedAction = `https://app.clientify.com/web-marketing/webforms/action/${formId}/`;
      const fallback = container.querySelector('[data-clientify-form-error]');
      const originalWrite = document.write.bind(document);
      let writeRestored = false;

      const restoreWrite = () => {
        if (writeRestored) return;
        document.write = originalWrite;
        writeRestored = true;
      };

      const showError = () => {
        restoreWrite();
        container.dataset.clientifyState = 'error';
        container.removeAttribute('aria-busy');
        fallback?.removeAttribute('hidden');
      };

      container.dataset.clientifyState = 'loading';
      container.setAttribute('aria-busy', 'true');
      document.write = (...chunks) => {
        container.insertAdjacentHTML('beforeend', chunks.map(String).join(''));
      };

      const script = document.createElement('script');
      script.src = formUrl;
      script.async = true;
      script.addEventListener('error', showError, { once: true });
      script.addEventListener('load', () => {
        restoreWrite();
        const form = container.querySelector('form');
        if (!form || form.action !== expectedAction) {
          showError();
          return;
        }

        container.dataset.clientifyState = 'ready';
        container.removeAttribute('aria-busy');
        if (typeof window.callSetupForm === 'function') window.callSetupForm();
      }, { once: true });
      document.head.appendChild(script);
    };

    const initClientifyForms = (root = document) => {
      root.querySelectorAll('[data-clientify-form-id]').forEach(initClientifyForm);
    };

    initClientifyForms();
    document.addEventListener('shopify:section:load', (event) => initClientifyForms(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["redlemon-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBrandShowcase = (scope = document) => {
      const showcases = scope.matches?.('[data-rl-brand-showcase]')
        ? [scope]
        : [...(scope.querySelectorAll?.('[data-rl-brand-showcase]') || [])];

      showcases.forEach((showcase) => {
        if (showcase.dataset.rlBrandInitialized === 'true') return;

        const tabs = [...showcase.querySelectorAll('[data-rl-brand-tab]')];
        const panels = [...showcase.querySelectorAll('[data-rl-brand-panel]')];
        const items = [...showcase.querySelectorAll('[data-rl-brand-item]')];
        const directLinks = [...showcase.querySelectorAll('[data-rl-brand-link]')];
        if (!tabs.length || tabs.length !== panels.length) return;

        showcase.dataset.rlBrandInitialized = 'true';
        const hasPreciseHover = window.matchMedia?.('(hover: hover) and (pointer: fine)').matches;

        const activate = (requestedIndex) => {
          const index = Math.max(0, Math.min(tabs.length - 1, Number(requestedIndex)));

          tabs.forEach((tab, tabIndex) => {
            const active = tabIndex === index;
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
          });

          items.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
          panels.forEach((panel, panelIndex) => {
            const active = panelIndex === index;
            panel.hidden = !active;
            panel.classList.toggle('is-active', active);
            panel.setAttribute('aria-hidden', active ? 'false' : 'true');
          });
        };

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activate(index));
          tab.addEventListener('focus', () => activate(index));
          if (hasPreciseHover) tab.addEventListener('mouseenter', () => activate(index));

          tab.addEventListener('keydown', (event) => {
            let nextIndex = index;
            if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
            else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
            else if (event.key === 'Home') nextIndex = 0;
            else if (event.key === 'End') nextIndex = tabs.length - 1;
            else return;

            event.preventDefault();
            activate(nextIndex);
            tabs[nextIndex].focus();
            tabs[nextIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
          });
        });

        directLinks.forEach((link, index) => {
          link.addEventListener('focus', () => activate(index));
          if (hasPreciseHover) link.addEventListener('mouseenter', () => activate(index));
        });

        const selectedIndex = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        activate(selectedIndex >= 0 ? selectedIndex : 0);
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initBrandShowcase());
    else initBrandShowcase();
    document.addEventListener('shopify:section:load', (event) => initBrandShowcase(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["redlemon-invoice-portal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializePortal = (portal) => {
      if (portal.dataset.invoiceInitialized === 'true') return;

      const form = portal.querySelector('[data-rl-invoice-form]');
      const orderInput = portal.querySelector('[data-rl-invoice-order]');
      const submitButton = portal.querySelector('[data-rl-invoice-submit]');
      const submitLabel = portal.querySelector('[data-rl-invoice-submit-label]');
      const status = portal.querySelector('[data-rl-invoice-status]');
      const exampleDialog = portal.querySelector('[data-rl-invoice-dialog]');
      const exampleDialogTitle = portal.querySelector('[data-rl-invoice-dialog-title]');
      const exampleDialogImage = portal.querySelector('[data-rl-invoice-dialog-image]');
      const exampleDialogClose = portal.querySelector('[data-rl-invoice-dialog-close]');

      if (!form || !orderInput || !submitButton || !submitLabel || !status) return;

      portal.dataset.invoiceInitialized = 'true';
      const defaultSubmitLabel = submitLabel.textContent;

      if (exampleDialog && exampleDialogTitle && exampleDialogImage && exampleDialogClose) {
        portal.querySelectorAll('[data-rl-invoice-example]').forEach((trigger) => {
          trigger.addEventListener('click', () => {
            exampleDialogTitle.textContent = trigger.dataset.exampleHeading;
            exampleDialogImage.src = trigger.dataset.exampleUrl;
            exampleDialogImage.alt = trigger.dataset.exampleAlt;
            exampleDialog.showModal();
          });
        });

        exampleDialogClose.addEventListener('click', () => exampleDialog.close());
        exampleDialog.addEventListener('click', (event) => {
          if (event.target === exampleDialog) exampleDialog.close();
        });
      }

      const setStatus = (message, state) => {
        status.textContent = message;
        status.dataset.state = state;
        status.hidden = false;
      };

      const setLoading = (loading) => {
        submitButton.disabled = loading;
        form.setAttribute('aria-busy', String(loading));
        submitLabel.textContent = loading ? portal.dataset.pendingMessage : defaultSubmitLabel;
      };

      orderInput.addEventListener('input', () => {
        orderInput.setCustomValidity('');
        status.hidden = true;
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const orderNumber = orderInput.value.trim();
        if (!orderNumber) {
          orderInput.setCustomValidity(portal.dataset.requiredMessage);
          orderInput.reportValidity();
          orderInput.focus();
          return;
        }

        orderInput.setCustomValidity('');
        setLoading(true);
        setStatus(portal.dataset.pendingMessage, 'pending');

        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 10000);

        try {
          const webhookUrl = new URL(portal.dataset.webhookUrl);
          const destinationUrl = new URL(portal.dataset.destinationUrl);

          if (webhookUrl.protocol !== 'https:' || destinationUrl.protocol !== 'https:') {
            throw new Error('Invalid portal configuration');
          }

          const response = await fetch(webhookUrl.toString(), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              order_number: orderNumber,
              source: 'shopify_portal',
              timestamp: new Date().toISOString()
            }),
            credentials: 'omit',
            signal: controller.signal
          });

          if (!response.ok) throw new Error('Invoice request failed');

          destinationUrl.pathname = `${destinationUrl.pathname.replace(/\/$/, '')}/loading`;
          destinationUrl.search = '';
          destinationUrl.searchParams.set('order', orderNumber);
          window.location.assign(destinationUrl.toString());
        } catch (error) {
          setLoading(false);
          setStatus(portal.dataset.requestError, 'error');
          status.focus?.();
        } finally {
          window.clearTimeout(timeout);
        }
      });
    };

    document.querySelectorAll('[data-rl-invoice-portal]').forEach(initializePortal);
    document.addEventListener('shopify:section:load', (event) => {
      const portal = event.target.querySelector('[data-rl-invoice-portal]');
      if (portal) initializePortal(portal);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
